import React, { memo } from 'react';
import { Button } from '@miroculus/nucleo';
import classnames from 'classnames/bind';
import styles from './Organization.scss';
const cx = classnames.bind(styles);
const SettingsSection = ({ onLeaveOrganization, }) => (React.createElement("section", { key: "organization-settings", className: cx('container--settings') },
    React.createElement("h2", { className: cx('title') }, "Settings"),
    React.createElement(Button, { flavor: "secondary", onClick: onLeaveOrganization, size: "small" }, "Leave Organization")));
export default memo(SettingsSection);
